import { EXPRESS_API } from 'configs/api/expressApi';
import { successToast } from 'lib/components/toasts/success';
import { useToastError } from 'lib/hooks';
import { useMutation, useQueryClient } from 'react-query';
import { landingPageDesignGroupsKeys } from './keys';

interface CreateLandingPageDesignGroupPayload {
  title: string;
  landingPageDesigns: number[];
}

interface CreateLandingPageDesignGroupParams {
  shouldShowNotifications?: boolean;
  shouldInvalidateLandingPages?: boolean;
  onSuccess?: () => void;
}

const createLandingPageDesignGroup = async (
  payload: CreateLandingPageDesignGroupPayload
) => {
  return (
    await EXPRESS_API.post(`/superadmin/landing-page-design-groups`, payload)
  )?.data;
};

export const useCreateGroupMutation = (
  params: CreateLandingPageDesignGroupParams
) => {
  const queryClient = useQueryClient();
  const { showError } = useToastError();
  const {
    shouldShowNotifications,
    shouldInvalidateLandingPages = true,
    onSuccess,
  } = params;

  return useMutation(
    (data: CreateLandingPageDesignGroupPayload) =>
      createLandingPageDesignGroup(data),
    {
      onSuccess: async () => {
        if (shouldShowNotifications) {
          successToast({
            title: 'Group has been successfully created!',
          });
        }

        await queryClient.refetchQueries(landingPageDesignGroupsKeys.all());
        if (shouldInvalidateLandingPages) {
          // refetch landing pages
          await queryClient.refetchQueries({
            queryKey: 'LANDING_PAGE_DESIGNS',
            exact: false,
          });
        }

        if (onSuccess) onSuccess();
      },
      onError: error =>
        showError(
          error || 'An error occured while trying to create the group!'
        ),
    }
  );
};
